import React from 'react';

import { HistoryStatus } from '../HistoryStatus';

export class HistoryStatuses extends React.Component {
    render() {
        return (
            <div>
                {this.props.history && this.props.history.map((item) => (
                    <HistoryStatus date={item.createdDate} key={item.id} statusID={item.statusID} thirdParty={this.props.thirdParty} />
                ))}
            </div>
        );
    }
}
